export const html = `
<div id="colourful-roosters"  class="ui">
  <!-- Back button -->
  <a href='#' id="back-btn">
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
  </a>

   <!-- ==== Finding ==== -->
  <div id="finding" style="display: block;">
    <!-- Aims border -->
    <div class="absolute top-1/2 left-1/2 z-[100] opacity-80 translate-x-[-50%] translate-y-[-65%]">
       <img src="/images/aim-border.svg" />
    </div>

    <!-- Image model -->
    <div id="lightbox" class="bg-[rgba(0,0,0,0.8)] fixed left-0 right-0 top-0 bottom-0 z-[1000] flex items-center justify-center" style="display: none;">
         <img id="lightbox-img" class="w-[90%]" src="" />
    </div>
  
    <!-- Target Image -->
    <div class="absolute bottom-4 left-1/2 translate-x-[-50%] z-[100] text-center" >
      <a id="target-image-button"
        href="#"
        style="display: block;" 
        >
         <img id="target-image" class="mx-auto rounded-[0.5rem] border-solid border-white border-4 overflow-hidden object-cover w-full max-w-[100px] mb-2" src="" />
      </a>
      <p class="mt-0 mb-0 text-white font-medium font-[1.3rem] flex-nowrap" style="text-shadow: 0 2px 6px rgba(0,0,0, 0.5);" >找出圖片中的圖案</p>
      <p class="mt-0 mb-0 text-white font-medium font-[1.3rem] flex-nowrap" style="text-shadow: 0 2px 6px rgba(0,0,0, 0.5);" >Find out this graphic</p>
    </div>
  </div>


 <!-- ==== Processing UI ==== -->
  <div id="processing-ui">
    <!-- Questions Dots -->
      <div id="dot-list" class="absolute w-full top-4 z-10 flex items-center justify-center mx-0 my-auto">
         <!-- Step 1 -->
         <div class="flex items-center">
            <div id="step-1-dot" class="w-8 h-8 bg-coloane-green border-solid border-4 border-white mr-0.5 flex items-center justify-center rounded-[50px]" style="box-shadow: 0 2px 15px rgba(0,0,0, 0.2);">
              <svg id="tick-1-icon" class="w-4 h-4 hidden" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.5 6L4.5 9L11.5 2" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
         </div>
        
         <!-- Step 2 -->
         <div class="flex items-center">
           <div id="step-2-line" class="h-1" style="background-color:rgba(255, 255, 255, 0.3);width: calc((100vw - 180px) / 10);"></div>
           <div id="step-2-dot" class="w-8 h-8 border-solid border-4 border-white mr-0.5 flex items-center justify-center rounded-[50px]" style="box-shadow: 0 2px 15px rgba(0,0,0, 0.2);">
             <svg id="tick-2-icon" class="hidden w-4 h-4" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.5 6L4.5 9L11.5 2" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
               </svg>
           </div>
         </div>
  
         <!-- Step 3 -->
         <div class="flex items-center">
           <div id="step-3-line" class="h-1" style="background-color:rgba(255, 255, 255, 0.3); width: calc((100vw - 180px) / 10);"></div>
           <div id="step-3-dot" class="w-8 h-8 border-solid border-4 border-white mr-0.5 flex items-center justify-center rounded-[50px]" style="box-shadow: 0 2px 15px rgba(0,0,0, 0.2);">
             <svg id="tick-3-icon" class="hidden w-4 h-4" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.5 6L4.5 9L11.5 2" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
               </svg>
           </div>
         </div>
     </div>
  
    <!--<div class="absolute top-12 left-1/2 -translate-x-1/2 z-[9] text-center" style="width: 90%">-->
    <!--    <p class="mt-0 mb-0 text-white font-bold opacity-80 text-[1.2rem]" style="text-shadow: 0 2px 6px rgba(0,0,0,0.8);">拍攝一張照片即可獲得優惠券</p>-->
    <!--    <p class="mt-0 mb-0 text-white font-bold opacity-80 text-[1.2rem]" style="text-shadow: 0 2px 6px rgba(0,0,0,0.8);">Take a photo to get coupon</p>-->
    <!--</div>-->
  </div>

  <!-- ==== Found ==== -->
    <div id="finish-ui" style="display: none;">
      <div id="backdrop" class="fixed top-0 right-0 left-0 bottom-0 z-[21] bg-[rgba(0,0,0,0.7)] animate__animated"></div>
        <!-- Logo -->
        <div class="-translate-y-[40%] fixed top-0 right-0 left-0 bottom-0 z-30 w-full p-8 flex items-center justify-center">
          <img class="h-[3rem]" src='/images/coloane-image/ogo-h-alpha.png' />
        </div>
       
      <div id="model-content" class="fixed top-[15%] left-[5%] bottom-[15%] right-[5%] bg-white rounded-2xl z-[21] flex text-center flex-col justify-between animate__animated">
        <!-- Pattern --> 
        <div class='absolute top-0 right-0 left-0 h-8 bg-[length:60%] bg-coloane-green rounded-tl-2xl rounded-tr-2xl coloane-pattern pattern-top'></div>
        <div class='absolute top-0 right-0 left-0 h-8 bg-[length:60%] bg-repeat rounded-tl-2xl rounded-tr-2xl coloane-pattern pattern-top' style="background-image: url('/images/coloane-image/coloane_pattern_alpha.png');"></div>

        <!-- Title -->
        <div class='text-[#F7B42C]' >
           <h1 class='m-0 text-[3rem]' style="font-family: 'tensentype-ruihei', system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji";">恭喜你</h1>
           <p class='m-0 text-[1rem] font-bold uppercase' style="font-family: 'tensentype-ruihei', system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji";">Congratulations</p>
        </div>


        <!-- Content -->
        <div class='content'>
           <h3 class="opacity-80 mb-0 text-[2rem] text-coloane-black">成功完成葡國公雞任務</h3>
           <!--<p class="opacity-70 py-0 px-[2rem] text-[1.1rem] leading-[1.6] text-coloane-black">完成其中4個AR互動後，即可獲得一次獲獎機會，抽取豐富獎品！</p>-->
        </div>

        <div style="margin-bottom: 3rem;" class='translate-x-[8%]'>
           <!--<button id="coloane-solid-btn" class='w-4/5 px-[0.9rem] py-0 rounded-[50px] font-bold text-[1rem] text-center text-white block mx-[0.5rem] my-auto decoration-0 bg-coloane-black btn">前往抽獎</button>-->
            <a href="https://coloane-macau.com/" id="rua-outline-btn" 
              class='w-4/5 py-[0.9rem] px-0 rounded-[50px] font-bold text-[1rem] text-center border-solid border-[0.2rem] border-coloane-black text-coloane-black block mx-[0.5rem] my-auto decoration-0 bg-white btn'
              >
              返回主頁
            </a>
        </div>
      </div>
    </div>
</div>

<a-scene
id="a-scene"
  ui-control
  renderer="colorManagement: true;"
  xrextras-gesture-detector
  xrextras-almost-there
  xrextras-loading
  xrextras-runtime-error
  xrweb>
  <a-assets>
    <!-- Ribbon -->
    <a-asset-item id="ribbon-model" src="/projects/coloane-macau/ar/colourful-roosters/models/ribbon.glb"></a-asset-item>

    <!-- Light -->
    <a-asset-item id="light-glb" src="/projects/coloane-macau/ar/colourful-roosters/models/light.glb"></a-asset-item>

    <!-- 鄭家大屋 -->
    <a-asset-item id="casa-glb" src="/projects/coloane-macau/ar/colourful-roosters/models/casa.glb"></a-asset-item>

    <!-- 市政署 -->
    <a-asset-item id="edificio-glb" src="/projects/coloane-macau/ar/colourful-roosters/models/edificio.glb"></a-asset-item>

    <!-- 燈塔 -->
    <a-asset-item id="farol-glb" src="/projects/coloane-macau/ar/colourful-roosters/models/farol.glb"></a-asset-item>

    <!-- 玫瑰堂 -->
    <a-asset-item id="igreja-glb" src="/projects/coloane-macau/ar/colourful-roosters/models/igreja.glb"></a-asset-item>

    <!-- 崗頂前地 -->
    <a-asset-item id="largo-glb" src="/projects/coloane-macau/ar/colourful-roosters/models/largo.glb"></a-asset-item>

    <!-- 港務局大樓 -->
    <a-asset-item id="quartel-glb" src="/projects/coloane-macau/ar/colourful-roosters/models/quartel.glb"></a-asset-item>

    <!-- 大三巴 -->
    <a-asset-item id="ruinas-glb" src="/projects/coloane-macau/ar/colourful-roosters/models/ruinas.glb"></a-asset-item>

    <!-- 媽閣廟 -->
    <a-asset-item id="templo-glb" src="/projects/coloane-macau/ar/colourful-roosters/models/templo.glb"></a-asset-item>
  </a-assets>

  

  <a-camera
    position="0 4 10"
    raycaster="objects: .cantap"
    cursor="fuse: false; rayOrigin: mouse;">
  </a-camera>

  <!--<a-light type="directional" intensity="0.5" position="1 1 1"></a-light>-->

  <a-light type="ambient" intensity="1"></a-light>


  <!-- Note: "name:" must be set to the name of the image target uploaded to the 8th Wall Console -->
  <!--<a-entity xrextras-named-image-target="name: macau-artdoor-3">-->
    
  <!--</a-entity>-->
  <a-entity id="target-anchor" colourful-roosters>
    <a-entity id='ar-content'>
       <!-- ribbon -->
       <a-entity  
       id="ribbon-entity"
       scale="0.01 0.01 0.01"
       position="0 0 0"
       gltf-model="#ribbon-model"
       ></a-entity>
  
       <!-- Light -->
        <a-entity  
       id="light-entity"
       scale="0.01 0.01 0.01"
       position="0 0 0"
       gltf-model="#light-glb"
       ></a-entity>

       <!-- 鄭家大屋 -->
        <a-entity  
       id="casa-entity"
       scale="0.01 0.01 0.01"
       position="0 0 0"
       visible="false"
       gltf-model="#casa-glb"
       ></a-entity>

       <!-- 市政署 -->
        <a-entity  
       id="edificio-entity"
       scale="0.01 0.01 0.01"
       position="0 0 0"
       visible="false"
       gltf-model="#edificio-glb"
       ></a-entity>

        <!-- 燈塔 -->
        <a-entity  
       id="farol-entity"
       scale="0.01 0.01 0.01"
       position="0 0 0"
       visible="false"
       gltf-model="#farol-glb"
       ></a-entity>

       <!-- 玫瑰堂 -->
        <a-entity  
       id="igreja-entity"
       scale="0.01 0.01 0.01"
       position="0 0 0"
       visible="false"
       gltf-model="#igreja-glb"
       ></a-entity>

       <!-- 崗頂前地 -->
        <a-entity  
       id="largo-entity"
       scale="0.01 0.01 0.01"
       position="0 0 0"
       visible="false"
       gltf-model="#largo-glb"
       ></a-entity>

       <!-- 港務局大樓 -->
        <a-entity  
       id="quartel-entity"
       scale="0.01 0.01 0.01"
       position="0 0 0"
       visible="false"
       gltf-model="#quartel-glb"
       ></a-entity>

       <!-- 大三巴 -->
        <a-entity  
       id="ruinas-entity"
       scale="0.01 0.01 0.01"
       position="0 0 0"
       visible="false"
       gltf-model="#ruinas-glb"
       ></a-entity>

       <!-- 媽閣廟 -->
        <a-entity  
       id="templo-entity"
       scale="0.01 0.01 0.01"
       position="0 0 0"
       visible="false"
       gltf-model="#templo-glb"
       ></a-entity>
     </a-entity>
  </a-entity>
  

</a-scene>


`
